import React from 'react';
import { Link } from 'react-router-dom';
import styles from './sections.module.css';
import ExpandableCard from '../ExpandableCard';

const MOMENTS = [
  {
    title: 'Details keep changing',
    body: 'Roles and numbers move on; a snapshot does not.',
  },
  {
    title: 'The meeting fades',
    body: 'A week later you have a name, not the room, the date, or what you promised.',
  },
  {
    title: 'The next step slips',
    body: 'Without a record, a good introduction stays a good introduction.',
  },
  {
    title: 'The network leaves with people',
    body: 'If contacts live on personal phones, the company does not keep them.',
  },
];

const ProblemSection = () => (
  <section className="vxm-section vxm-section--raised" id="after-hello">
    <div className="vxm-container">
      <div className="vxm-section-head vxm-reveal">
        <p className="vxm-eyebrow">What happens after hello?</p>
        <h2 className="vxm-h2">The introduction is the easy part</h2>
        <p className="vxm-body">
          Most new contacts never become a second conversation, not
          because the meeting failed, but because nothing kept the person, the
          context, or the next step.
        </p>
      </div>

      <div className={styles.problemGrid}>
        {MOMENTS.map((moment) => (
          <div key={moment.title} className="vxm-reveal">
            <ExpandableCard title={moment.title} alwaysOpenOnDesktop>
              <p className="vxm-body">{moment.body}</p>
            </ExpandableCard>
          </div>
        ))}
      </div>

      <p className={`vxm-body ${styles.originNote} vxm-reveal`}>
        Velox was built because paper cards still end up in a drawer, sharing a
        number can feel awkward, and LinkedIn rarely keeps the private context
        that makes a follow-up possible.{' '}
        <Link to="/why-velox" className="vxm-link">
          Read the story
        </Link>
        .
      </p>
    </div>
  </section>
);

export default ProblemSection;
